import React, { createContext, useContext, useState } from 'react';

const ReplaceSavingContext = createContext(null);

export function ReplaceSavingProvider({ children }) {
  const [replaceSavingInProgress, setReplaceSavingInProgress] = useState(false);
  return (
    <ReplaceSavingContext.Provider value={{ replaceSavingInProgress, setReplaceSavingInProgress }}>
      {children}
    </ReplaceSavingContext.Provider>
  );
}

export function useReplaceSaving() {
  const ctx = useContext(ReplaceSavingContext);
  return ctx;
}
